import { render, staticRenderFns } from "./errorspan.vue?vue&type=template&id=7715bad6&"
import script from "./errorspan.vue?vue&type=script&lang=js&"
export * from "./errorspan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports